<template>
	<div class="specifications" @click="share(false)" v-if="shareClose.type" :style="{opacity: (shareClose.translateY == 0 ? 1:0)}">
		<div class="share-translateY" :style="'transform:translateY('+shareClose.translateY+');'" v-if="angle == 'down' || angle == 'up'">
			<div @click="share(true)" class="share-div" :style="{height: height}">
				<slot></slot>
			</div>
		</div>
		<div class="share-translateY" :style="'transform:translateX('+shareClose.translateY+');'" v-if="angle == 'left' || angle == 'right'">
			<div @click="share(true)" class="share-div" :style="{height: height,width: width}">
				<slot></slot>
			</div>
		</div>
	</div>
</template>
<script>
	// up		上
	// down 	下
	// left	左
	// right	右

	export default {
		props: {
			angle: {
				type: String,
				default: 'down'
			},
			height: {
				type: String,
				default: '100%'
			},
			width: {
				type: String,
				default: '100%'
			},
			bomb_show:{
				type: Boolean,
				default: false
			}
		},
		created() {
			if(this.bomb_show == true){
				this.share(true);
			}
		},
		data() {
			return {
				isLeft: [false, false],
				shareClose: {
					type: false,
					translateY: '100%'
				}
			}
		},
		methods: {
			show(close) {
				if (close) {
					this.shareClose = {
						type: true,
						translateY: '0%'
					}
				} else {
					this.shareClose = {
						type: false,
						translateY: '100%'
					}
				}
			},
			share(e) {
				let details = this;
				let isLeft = details.isLeft;
				let zero = 0;
				let one = 1;
				if (!isLeft[zero]) {
					e ? isLeft[one] = true : isLeft[zero] = true;
					setTimeout(function() {
						if (isLeft[one]) {
							isLeft[zero] = false;
						}
						if (isLeft[zero]) {
							isLeft[zero] = false;
							isLeft[one] = false;
							// -------------------功能区域-------------------//
							let shareClose = details.shareClose;
							shareClose.translateY = details.angle == 'left' || details.angle == 'up' ? '-100%' : '100%';
							details.shareClose = shareClose;
							setTimeout(function() {
								shareClose.type = false;
								details.shareClose = shareClose;
							}, 500)
							// -------------------功能区域-------------------//
							details.isLeft = isLeft; //小程序的函数
						} else {
							isLeft[zero] = false;
							isLeft[one] = false;
							// -------------------功能区域-------------------//
							let shareClose = details.shareClose;

							if (shareClose.type) {
								return;
							}
							shareClose.type = true;
							shareClose.translateY = details.angle == 'left' || details.angle == 'up' ? '-100%' : '100%';
							details.shareClose = shareClose;

							setTimeout(function() {
								shareClose.translateY = 0;
								details.shareClose = shareClose;
							}, 100)
							// -------------------功能区域-------------------//
							details.isLeft = isLeft; //小程序的函数
						}
					}, 300)
				}
			}
		}
	}
</script>

<style lang="less">
	.specifications {
		width: 100%;
		height: 100%;
		position: fixed !important;
		z-index: 1000;
		background-color: rgba(0, 0, 0, 0.3);
		bottom: 0;
		left: 0;
		display: flex;
		flex-direction: column;
		justify-content: flex-end;
		align-items: flex-end;
		transition: .5s;
		
		.share-translateY {
			width: 100%;
			background-color: rgba(0, 0, 0, 0);
			display: flex;
			flex-direction: column;
			justify-content: flex-end;
			transition: .5s;
			height: 100%;
		}
		
		.share-div {
			display: flex;
			flex-direction: column;
			justify-content: flex-end;
			background-color: #FFFFFF;
		}
	}

</style>
